export const initiateCancelUploadProcess = (abortControllerRef, openModal) => {
  if (abortControllerRef.current) {
    openModal(); // Open the cancel confirmation modal
  }
};

export const cancelUpload = (
  abortControllerRef,
  setIsUploading,
  setUploadProgress,
  closeModal
) => {
  if (abortControllerRef.current) {
    abortControllerRef.current.abort(); // Cancel the request
    abortControllerRef.current = null; // Reset the controller
    setIsUploading(false);
    setUploadProgress(0);
    closeModal();
  }
};

export const retryUpload = (uploadFailed, lastFile, handleUpload) => {
  if (uploadFailed && lastFile) {
    handleUpload([lastFile]);
  }
};

export const keepUploading = (closeModal) => {
  closeModal(); // Close the modal
};
